import * as React from 'react';
import { FC } from 'react';
import Image from 'next/future/image';
import { InspirationType } from 'types/types';

interface IInspirationListItem {
  inspiration: InspirationType;
}

const InspirationList: FC<IInspirationListItem> = ({ inspiration }) => {
  return (
    <div className="inspirationList">
      <div className="inspirationList__card">
        <div className="inspirationList__card-image">
          {inspiration.image && (
            <Image
              src={inspiration.image}
              alt={inspiration.name}
              width={704}
              height={195}
            />
          )}
        </div>
        <div className="inspirationList__card-info">
          <h4>{inspiration.name}</h4>
          <p>{inspiration.description}</p>
        </div>
      </div>
    </div>
  );
};

export default InspirationList;
